/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMemoryStoresCreate } from "../../funcs/llmMemoryStoresCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateMemoryStoreRequest$inboundSchema,
};

export const tool$llmMemoryStoresCreate: ToolDefinition<typeof args> = {
  name: "llm-memory-stores-create",
  description: `Create memory store

Creates a memory store for persistent agent notes. Stores are private by default and can be shared across the workspace.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMemoryStoresCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
